import { memo } from "react";
import { GroupedTable } from "../../../common/components/functional/GroupedTable/GroupedTable";
import LoadingSpinner from "../../../common/components/functional/loadingSpinner/LoadingSpinner";
import { TablePaginationProps } from "../../../common/components/functional/pagination/types";
import { ItemGroup } from "../../invoices/invoiceAPI";
import { ORDER_COLUMNS } from "../constants";
import { OrderRowDisplayFormatted } from "../types/common";

type Props = {
  isLoading: boolean;
  orderGroups: ItemGroup<OrderRowDisplayFormatted>[];
  paginationProps: TablePaginationProps;
  itemCount: number;
};

const OrdersTableComponent = ({
  isLoading,
  orderGroups,
  paginationProps,
  itemCount,
}: Props) => {
  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <GroupedTable
      columns={ORDER_COLUMNS}
      groups={orderGroups}
      pagination={paginationProps}
      itemCount={itemCount}
      translation={"order"}
      updateSelectedItems={() => {}}
      disableSelectItems
      disableSelectAllItems
      hideAllCheckboxes
    />
  );
};

export const OrdersTable = memo(OrdersTableComponent);
